import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { backendApi } from './base.config';
import { authenticationMiddleware } from './middleware';
import { persistReducer, persistStore } from 'redux-persist';
import { commonSlice } from './common.slice';
import storage from "redux-persist/lib/storage";

const commonPersistConfig = {
    key: "common",
    version: 1,
    storage
};
const reducer = combineReducers({
    [backendApi.reducerPath]: backendApi.reducer,
    [commonSlice.name]: persistReducer(commonPersistConfig, commonSlice.reducer),
});

export const store = configureStore({
    reducer: reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }).concat(backendApi.middleware),  // removed authenticationMiddleware since refresh token is implemented
})

export const persistor = persistStore(store)



